import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import AdminLayout from '../components/AdminLayout';
import RequireAuth from '../components/RequireAuth';
import { useSession } from '../hooks/useSession';
import { identifySentryUser } from '../services/sentry';
import AccountsRoutes from './accounts';
import AuthRoutes from './auth';
import BrandsRoutes from './brands';
import BullBoardPage from './bull-board';
import Home from './Home';
import NotFoundPage from './NotFound.page';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function PagesRoot(): JSX.Element {
  const { userId } = useSession();

  useEffect(() => {
    if (!userId) return;

    identifySentryUser({
      id: userId,
    });
  }, [userId]);

  return (
    <SentryRoutes>
      <Route
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Home />} />
        <Route path="accounts/*" element={<AccountsRoutes />} />
        <Route path="brands/*" element={<BrandsRoutes />} />
      </Route>

      <Route path="auth/*" element={<AuthRoutes />} />
      <Route path="bull-board" element={<BullBoardPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </SentryRoutes>
  );
}

export default PagesRoot;
